$(function () {
    const filtersContainersClass = '.products-filter--container';
    const productToolsFiltersContainerClass = '.product-tools-filters';
    const $filtersContainer = $('.products-filter--container');
    const $sideScrollBtnPrev = $('#scrollNavFiltersPrev');
    const $sideScrollBtnNext = $('#scrollNavFiltersNext');
    const $sideScrollContainer = $('.navSideScroll');
    const sliderContainer = document.querySelector('.catalog-nav__sub-items');
    const sideScrollContainer = document.querySelector('.navSideScroll');
    let sliderScrollWidth;
    let  sliderWidth;
    if ($sideScrollContainer.length != 0){
        sliderScrollWidth = sideScrollContainer.scrollWidth;
        sliderWidth = sliderContainer.offsetWidth;
    }
    let lastFilterValue = '';
    let lastSelectedFilterId = '';

    /**************************************************************************
     * PRODUCT FILTER FUNCTIONS (EGC COMPONENT)
     **************************************************************************/
    $('.products-view li a[href=#]').click(function (e) {
        TINK.setCookie('pageSize', $(this).attr('data-page-size'));
        window.location = $(this).attr('data-href');
        e.preventDefault();
    });

    $('.product-filter-container .pt--filter-selected button').click(function () {
        navigate($(this).data('custom'), $(this).data('href'), false, false);
    });

    bindEventOnFilterClick($(filtersContainersClass));
    bindEventOnProductToolsFilterClick($(productToolsFiltersContainerClass));
    bindShowHideMoreFilters($(filtersContainersClass));
    bindToggleFilter($(filtersContainersClass));

    //****************************************************************
    // Bind
    //****************************************************************

    const manageCloseFilterOverlay = function (hasNewFilter) {
        if (hasNewFilter) {
            deactivateMobileFilters($(filtersContainersClass));
            window.location = $(filtersContainersClass).find('a.applyFilters').attr('href');
        } else {
            $('.filter-overlay').on('click', function (e) {
                if (e.target === this) {
                    $('.closeFilter').click();
                }
            });
        }
    }

    $(document).on('click', '.closeFilter', function () {
        $('body').removeClass('overflow-hidden');
        $filtersContainer.removeClass('pf--active');
        $('.filter-overlay').remove();
        $('.openFilter').attr('aria-expanded', 'false');
    });

    function bindEventOnFilterClick($container) {
        $container.find('a.applyFilters').on('click', function () {
            const currentURL = window.location.href;
            if (currentURL.includes("/allees/") || currentURL.includes("/aisles/")) {
                const selectedFilters = [];
                $container.find(".checkbox--standard input[type=checkbox]:checked").each(function () {
                    const selectedFiltersCategory = $(this).closest('.accordion--item').find('.accordion--btn').text().toLowerCase();
                    const selectedFiltersOption = $(this).siblings('.checkbox--label').find('.filter-name').text().toLowerCase();

                    selectedFilters.push({selectedFiltersCategory, selectedFiltersOption})

                    pushDataLayerProductCatalogFilterBy(selectedFiltersCategory, selectedFiltersOption);
                });

                $container.find(".checkbox--standard input[type=checkbox]:checked").prop('checked', false);
            }
            sessionStorage.setItem('isFromFilter', true);
        });

        $container.find(".checkbox--standard input[type=checkbox]").change(function () {
            lastSelectedFilterId = this.id;
            navigate($(this).data('custom'), $(this).attr('value'), false, true);
        });

        $container.find('a.removeAllFilters').on('click', function () {
            navigate(false, null, true, true);
            sessionStorage.setItem('isFromFilter', true);
        });

        $container.find('a.applyFilters').on('click', function () {
            deactivateMobileFilters($container);
        });


        $('.openFilter').bind('click', function () {
            const $body = $('body');
            $body.addClass('overflow-hidden');
            $filtersContainer.addClass('pf--active');
            $body.append('<span class="filter-overlay" />');
            manageCloseFilterOverlay(false);
        });

        $('.filter-overlay').on('click', function (e) {
            if (e.target === this) {
                manageCloseFilterOverlay(true);
            }
        });

        $container.find('a.applyFilters').attr('href', lastFilterValue);
    }

    function bindEventOnProductToolsFilterClick($container) {

        $container.find(".checkbox--standard input[type=checkbox]").change(function () {
            if ($(this).is(':checked')) {
                pushDataLayerProductCatalogFilterBy($(this).data('facet-name'), $(this).data('facet-value'));
            }
        });

        $container.find(".checkbox--standard input[type=checkbox]").change(function () {
            lastSelectedFilterId = this.id;
            navigate($(this).data('custom'), $(this).attr('value'), false, false);
        });

        $container.find('a.removeAllFilters').on('click', function () {
            navigate(false, null, true, false);
            sessionStorage.setItem('isFromFilter', true);
        });
    }

    function bindShowHideMoreFilters($container) {
        if ($container === undefined) {
            $container = $(filtersContainersClass);
        }

        $container.on('click.filtersToggle', '.js-show-more-filters', function () {
            const $this = $(this);
            const loadCount = $this.attr('data-load-count') || 0;

            loadFilter(this.previousElementSibling, loadCount, loadFilterCallback);

            $this.siblings('.js-extra-filters').show();
        });
    }


    function loadFilterCallback(trigger, nextCount) {
        const $trigger = $(trigger);

        if (nextCount > 0) {
            $trigger.find('.js-show-more-label .js-next-count').text(nextCount);
            $trigger.attr('data-load-count', nextCount);
        } else {
            $trigger.removeClass('js-show-more-filters');
            $trigger.addClass('js-hide-all-filters');
            $trigger.children('.js-show-more-label').hide();
            $trigger.children('.js-hide-all-label').show();
            $trigger.attr('aria-expanded', 'true');
            $trigger.off('click.filtersToggle');
            $trigger.on('click.filtersToggle', hideAllFilters);
        }
    }

    function hideAllFilters() {
        const $this = $(this);
        $this.removeClass('js-hide-all-filters');
        $this.addClass('js-show-all-filters');
        $this.children('.js-hide-all-label').hide();
        $this.children('.js-show-all-label').show();
        $this.attr('aria-expanded', 'false');
        $this.off('click.filtersToggle');
        $this.on('click.filtersToggle', showAllFilters);
        $this.siblings('.js-extra-filters').slideUp('fast');
    }

    function showAllFilters() {
        const $this = $(this);
        $this.removeClass('js-show-all-filters');
        $this.addClass('js-hide-all-filters');
        $this.children('.js-show-all-label').hide();
        $this.children('.js-hide-all-label').show();
        $this.attr('aria-expanded', 'true');
        $this.off('click.filtersToggle');
        $this.on('click.filtersToggle', hideAllFilters);
        $this.siblings('.js-extra-filters').slideDown('fast');
    }

    function bindToggleFilter($container) {
        $container.on('click', '.accordion--btn', function () {
            $(this).toggleClass('active--filter');
        });
    }

    //****************************************************************
    // Features
    //****************************************************************
    function loadFilter(filter, nbToLoad, callback) {
        let $filter = $(filter);
        let filterContainer = $filter.closest(filtersContainersClass);

        deactivateMobileFilters(filterContainer);

        let data = {
            filter: $filter.attr("data-load-more"),
            nbToLoad: nbToLoad,
            offset: $filter.children('.checkbox--standard').length,
            searchId: searchId
        };
        $.ajax({
            url: productSearchFilterUrl + fromEcomFlyerUniqueParam,
            type: 'POST',
            data: JSON.stringify(data),
            dataType: "html",
            header: {
                'Accept-Language': window['acceptLanguage']
            },
            contentType: 'application/json; charset=utf-8',
            success: function (responseData) {
                $filter.append(responseData);
                bindEventOnFilterClick($filter);
                bindShowHideMoreFilters($filter);
                bindToggleFilter($filter);
                injectSVG();
            },
            error: function (jqXHR, status, error) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.warn("Error when trying to load the filter selection fragment " + error);
                }
            },
            complete: function () {
                onExtraFiltersChange($filter, callback);
                activateMobileFilters(filterContainer);
            }
        });
    }

    function onExtraFiltersChange($filter, callback) {
        const $trigger = $filter.siblings('.js-show-more-filters:first');
        const displayedValuesCount = $filter.children('.js-filter-value').length;
        const totalValuesCount = $filter.attr('data-values-count');
        const remainingValuesCount = totalValuesCount - displayedValuesCount;

        if (callback !== undefined && callback instanceof Function) {
            const loadCount = $trigger.attr('data-load-count') || 0;
            const nextCount = Math.min(remainingValuesCount, loadCount);

            callback($trigger, nextCount);
        }
        if (remainingValuesCount <= 0) {
            deleteFilter($filter.attr("data-load-more"));
        }
    }

    function deleteFilter(filterName) {
        let data = {
            filter: filterName,
            searchId: searchId
        };

        $.ajax({
            url: productSearchFilterUrl,
            type: 'DELETE',
            data: JSON.stringify(data),
            header: {
                'Accept-Language': window['acceptLanguage']
            },
            contentType: 'application/json; charset=utf-8',
            error: function (jqXHR, status, error) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.warn("Error when trying to clean filters from user's session " + error);
                }
            }
        })
    }

    function applyFiltersProductAjax(filtersUrl, isResetAllFilters) {
        let $mobileFiltersContainer = $(filtersContainersClass);
        deactivateMobileFilters($mobileFiltersContainer);

        function focusOnLastSelectedCheckbox() {
            if (lastSelectedFilterId !== '') {
                // do not use $('#' + lastSelectedFilterId) since 'id' might contain characters breaking the js (ex: 'mob-100%petit')
                $('[id="' + lastSelectedFilterId + '"]').focus();
            }
        }

        // Remember already loaded extra filters in order to keep them after the section is refreshed
        const filterStats = [];
        if (!isResetAllFilters) {
            $mobileFiltersContainer.find('.js-extra-filters').each(function () {
                const $this = $(this);
                filterStats.push({
                    'filterName': $this.data('load-more'),
                    'extraFilterValuesCount': $this.find('.js-filter-value').length
                });
            });
        }

        $.ajax({
            type: 'POST',
            url: filtersUrl,
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({
                'currentAisleId': currentAisleId,
                'filterStats': filterStats
            }),
            success: function (data, textStatus, jqXHR) {
                replaceSearchProductFiltersContent(data, jqXHR);
                bindEventOnFilterClick($mobileFiltersContainer);
                focusOnLastSelectedCheckbox();
                injectSVG();
            },
            error: function (jqXHR, status, error) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.warn("Error to apply filters " + error);
                }
            },
            complete: function () {
                $mobileFiltersContainer.find('.js-extra-filters').each(function () {
                    const $extraFilters = $(this);
                    if ($extraFilters.find('.js-filter-value').length > 0) {
                        onExtraFiltersChange($extraFilters, loadFilterCallback);
                    }
                });
                activateMobileFilters($mobileFiltersContainer);
            }
        });
    }

    function navigate(isCustom, filterValue, isResetAllFilters, isAjax) {
        let url = isAjax ? productSearchRefreshFiltersUrl + appendUrl(currentSortUrl) : pageUrl + appendUrl(currentSortUrl);

        if (filterValue !== null) {
            lastFilterValue = pageUrl + appendUrl(currentSortUrl);

            let filter;
            if (isCustom) {
                filter = currentHybrisQuery + appendFilter('&customFilter=', filterValue);
            } else {
                filter = appendFilter('&filter=', filterValue) + currentCustomQuery;
            }
            url += filter;
            lastFilterValue += filter;

        } else {
            if (isResetAllFilters) {
                lastFilterValue = pageUrl;
                url = isAjax ? productSearchRefreshFiltersUrl : pageUrl;
            } else {
                url += currentFilter;
                lastFilterValue = pageUrl + appendUrl(currentSortUrl) + currentFilter;
            }
        }

        if (isAjax) {
            applyFiltersProductAjax(url, isResetAllFilters);
        } else {
            window.location = TINK.validateUrl(url);
        }
    }

    function conditionArrowFade () {
        if(sideScrollContainer.scrollLeft === 0) {
            $sideScrollBtnPrev.addClass("disabled");
            $sideScrollBtnPrev.children().addClass("disabled");
            $sideScrollContainer.removeClass("scroll-left");
        } else{
            $sideScrollBtnPrev.removeClass("disabled");
            $sideScrollBtnPrev.children().removeClass("disabled");
            $sideScrollContainer.addClass("scroll-left");
        }
        if(((sliderContainer.scrollWidth - 55) + sideScrollContainer.scrollLeft) > sideScrollContainer.scrollWidth){
            $sideScrollBtnNext.addClass("disabled");
            $sideScrollBtnNext.children().addClass("disabled");
            $sideScrollContainer.removeClass("scroll-right");

        } else{
            $sideScrollBtnNext.removeClass("disabled");
            $sideScrollBtnNext.children().removeClass("disabled");
            $sideScrollContainer.addClass("scroll-right");
        }
    }

    function scrollNavFilters () {
        const sideScrollDistance = 200;

        $sideScrollBtnNext.removeClass("disabled");
        $sideScrollBtnNext.children().removeClass("disabled");

        function sideScroll(element,direction,speed,distance,step){
            scrollAmount = 0;
            var slideTimer = setInterval(function(){
                if(direction == 'left'){
                    element.scrollLeft -= step;
                } else {
                    element.scrollLeft += step;
                }
                scrollAmount += step;
                if(scrollAmount >= distance){
                    window.clearInterval(slideTimer);
                }
            }, speed);
        }

        function clickArrowToScroll(btnArrow, actionToScroll){

            btnArrow.on(actionToScroll, function() {

                if(btnArrow == $sideScrollBtnPrev){
                    sideScroll(sideScrollContainer,'left',25,sideScrollDistance,10);
                }

                if(btnArrow == $sideScrollBtnNext){
                    sideScroll(sideScrollContainer,'right',25,sideScrollDistance,10);
                }

                if(Revealizr.isDesktopSize){
                    conditionArrowFade()
                }

            })
        }

        clickArrowToScroll($sideScrollBtnNext, 'click');
        clickArrowToScroll($sideScrollBtnPrev, 'click');
        clickArrowToScroll($sideScrollContainer, 'mousemove');

    }

    function scrollToSelectedCategory () {
        const selectedCategory = document.querySelector('.selected_category');
        let positionSelectedCategory = selectedCategory.offsetLeft;

        sideScrollContainer.scrollBy({
            left: positionSelectedCategory - 90,
            behavior: 'smooth'
        });


        if(Revealizr.isDesktopSize){
            conditionArrowFade()
        }
    }

    if ($('.catalog-nav__sub-items').length && Revealizr.isDesktopSize) {
        let isDown = false;
        let startX;
        let scrollLeft;

        if (sliderScrollWidth > (sliderWidth - 55)) {
            scrollNavFilters();
        }

        sideScrollContainer.addEventListener('mousedown', (e) => {
            isDown = true;
            sideScrollContainer.classList.add('active');
            startX = e.pageX - sideScrollContainer.offsetLeft;
            scrollLeft = sideScrollContainer.scrollLeft;
        });
        sideScrollContainer.addEventListener('mouseleave', () => {
            isDown = false;
            sideScrollContainer.classList.remove('active');
        });
        sideScrollContainer.addEventListener('mouseup', () => {
            isDown = false;
            sideScrollContainer.classList.remove('active');
        });
        sideScrollContainer.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - sideScrollContainer.offsetLeft;
            const walk = (x - startX) * 2; //scroll-fast
            sideScrollContainer.scrollLeft = scrollLeft - walk;
        });
    }

    //****************************************************************
    // Update dom
    //****************************************************************
    function replaceSearchProductFiltersContent(data, jqXHR) {
        data = data.trim();
        let $container = $filtersContainer.find('.product-filter--form-content');
        let $result = $($.parseHTML(data));
        $container.html($result.find('.product-filter--form-content'));
        $container.find('[data-module="dishide"]').dishide();
        searchId = jqXHR.getResponseHeader("searchId");
    }

    //****************************************************************
    // Progress indicator
    //****************************************************************
    function deactivateMobileFilters($container) {
        if ($container === undefined) {
            $container = $(filtersContainersClass);
        }
        $container.find('button').attr('disabled', true);
        $container.find('input[type=checkbox]').attr('disabled', true);
        $container.find('.product-filter--progress-indicator').addClass('veil');
    }

    function activateMobileFilters($container) {
        if ($container === undefined) {
            $container = $(filtersContainersClass);
        }
        $container.find('button').removeAttr('disabled');
        $container.find('input[type=checkbox]').removeAttr('disabled');
        $container.find('.product-filter--progress-indicator').removeClass('veil');
    }

    //****************************************************************
    // Util
    //****************************************************************
    function appendFilter(name, value) {
        return value ? name + value : '';
    }

    function appendUrl(url) {
        return url ? url : '';
    }

    if (sliderScrollWidth > (sliderWidth - 55)) {
        scrollToSelectedCategory();
    }

});
